export const GAME_STUDIOS_MAP = {
    ash: ['Ash', 'SOF', 'ASH'],
    geco: ['Geco'],
    origins: ['Origins', 'GIB', 'Ingenuity', 'Ishir', 'Kiev', 'Origins Gibraltar', 'TAR', 'TLV'],
    psiclone: ['Psiclone'],
    rarestone: ['RareStone'],
    skywind: ['Skywind (Australia Studio)', 'Skywind (Kiev Studio)'],
    sunfox: ['Sunfox', 'SunFox'],
    vikings: ['Vikings'],
    eyecon: ['Eyecon'],
    quickspin: ['Quickspin']
};

export const GAME_CODES_MAP = {
    chel: 'chel (HTML5: cheaa, Native: hldn)',
    cheaa: 'chel (HTML5: cheaa, Native: hldn)',
    ro: 'ro (HTML5: mobro, Native: mrn_eu)',
    mobro: 'ro (HTML5: mobro, Native: mrn_eu)',
    dt: 'dt (HTML5: mobdt)',
    mobdt: 'dt (HTML5: mobdt)',
    hb: 'hb (HTML5: ano)',
    ano: 'hb (HTML5: ano)',
    gtsrkysc: 'gtsrkysc (HTML5: mrbsc)',
    mrbsc: 'gtsrkysc (HTML5: mrbsc)',
    kj: 'kj (NGM: kjdup)',
    kjdup: 'kj (NGM: kjdup)',
    zeus: 'zeus (Mobile: kolymp)',
    kolymp: 'zeus (Mobile: kolymp)'
};
